export default __webpack_public_path__ + "static/media/06.75a35bf7.webp";